function CustomFunction(){
   var myInput = document.getElementById("newPassword") as HTMLInputElement;
   var letter = document.getElementById("letter");
   var capital = document.getElementById("capital");
   var number = document.getElementById("number");
   var special = document.getElementById("special");
   var length = document.getElementById("length");
   myInput.onkeyup = function() {
   var lowerCaseLetters = /[a-z]/g;
  if (myInput?.value.match(lowerCaseLetters)) {
  letter?.classList.remove("password-invalid");
  letter?.classList.add("password-valid");
  } else {
  letter?.classList.remove("password-valid");
  letter?.classList.add("password-invalid");
   }
  
   var upperCaseLetters = /[A-Z]/g;
  if (myInput?.value.match(upperCaseLetters)) {
   capital?.classList.remove("password-invalid");
  capital?.classList.add("password-valid");
   } else {
   capital?.classList.remove("password-valid");
   capital?.classList.add("password-invalid");
   }
   var numbers = /[0-9]/g;
   if (myInput?.value.match(numbers)) {
   number?.classList.remove("password-invalid");
   number?.classList.add("password-valid");
  } else {
   number?.classList.remove("password-valid");
   number?.classList.add("password-invalid");
   }
  
  
  var specialCharacters = /[`@!#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/g;
  if (myInput?.value.match(specialCharacters) ) {
   special?.classList.remove("password-invalid");
   special?.classList.add("password-valid");
   } else {
   special?.classList.remove("password-valid");
   special?.classList.add("password-invalid");
   }
  
  if (myInput?.value?.length >= 8) {
   length?.classList.remove("password-invalid");
   length?.classList.add("password-valid");
  } else {
  length?.classList.remove("password-valid");
   length?.classList.add("password-invalid");
  }
   }}
  
   export {CustomFunction};